import React, { Component } from "react";
import {
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  UncontrolledDropdown,
} from "reactstrap";
import Slider from '@mui/material/Slider';
import Calender from "../calender";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { redirect, searchedHb, sideBarHeberg } from "../../../slices/sbHebergSlice";
import httpClient from "../../../httpClient";
import { faMapMarkerAlt, faSearch, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UrlParams from "../urlParams";
import DateRangePicker from '@mui/lab/DateRangePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import moment from "moment";


class SideBarHeberg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchParams: {
        pays: "",
        region: "",
        commune: "",
        dateDebut: "",
        dateFin: "",
        adult: 1,
        enfant: 0,
        room: 1,
        budget: [0, 1000],
        type: [],
        repas: [],
        conditions: [],
        equipement: [],
      },
      DateRange: [null, null],
      budget: [],
      autocompletePlaces: [],
      showAutoComp: false
    };
    // this.showAutoComp = this.showAutoComp.bind(this);
  }


  async componentDidUpdate(prevProps, prevState) {
    this.props.dispatch(sideBarHeberg(this.state.searchParams));
    if (this.props.redirect === true && prevProps.url !== this.props.url) {
      this.props.history.push("/hebergement/advanced_search" + "?" + this.props.url)
      const searchedAnnounces = await httpClient.getSearchedAnnounces(this.props.url)
      this.props.dispatch(searchedHb(searchedAnnounces))
      this.props.dispatch(redirect(false))
    }
  }

  async componentDidMount() {
    this.setState({ date: [] })
    let completeUrl = decodeURIComponent(window.location.href.toString())
    let prms = completeUrl.replace(window.location.hostname.toString(), "").replace(window.location.pathname.toString(), "")
    let pos = prms.indexOf("?")
    prms = prms.substring(pos + 1, prms.length)
    let urlParams = new UrlParams(prms, 1).parInts('adult', 'enfant', 'room')
    let obj = this.state.searchParams

    Object.entries(urlParams).map(prop => {
      if (prop[0] === "type" || prop[0] === "repas" || prop[0] === "conditions" || prop[0] === "equipement") {
        obj[prop[0]] = prop[1].replaceAll('+', " ").split(',')
      }
      else obj[prop[0]] = prop[1]
    })
    // alert(JSON.stringify(obj))
    this.setState({
      searchParams: obj
    })
    const searchedAnnounces = await httpClient.getSearchedAnnounces(this.props.url || prms)

    this.props.dispatch(searchedHb(searchedAnnounces))
    this.props.dispatch(redirect(false))
  }

  isExist(type, value) {
    let copie = this.state.searchParams[type]
    return copie.includes(value.toLowerCase())
  }

  changeState(evt) {
    let value = evt.target.value;
    let name = evt.target.name;
    const copie = this.state.searchParams[name];

    this.setState({
      searchParams: {
        ...this.state.searchParams,
        [name]: value,
      }

    });

    if (evt.target.type === "radio") {
      this.setState({
        searchParams: {
          ...this.state.searchParams,
          budget: value,
        }
      });
    } else if ((evt.target.type === "checkbox")) {
      let index = copie.indexOf(value);
      if (index === -1) {
        this.setState({
          searchParams: {
            ...this.state.searchParams,
            [name]: [...this.state.searchParams[name], value],
          }
        });
      } else {
        this.setState({
          searchParams: {
            ...this.state.searchParams,
            [name]: copie.filter((item) => item !== value),
          }
        });
      }
    }
  }

  city(e, city, country) {
    e.preventDefault()
    this.setState({
      searchParams: {
        ...this.state.searchParams,
        pays: country,
        region: city,
      },
      showAutoComp: false
    },
    )
  }

  autoComplete(evt) {
    try {
      if (evt.target.value !== "") {
        this.setState({ autocompletePlaces: evt.target.value })
        // httpClient.autocompletePlaces(evt.target.value).then((res) => {
        //   if (res) {
        //     this.showAutoComp(true)
        //     return this.setState({ autocompletePlaces: res.data })
        //   }
        // }
        //)

      }


    } catch (error) {
      console.log(error);
    }
  }

  showAutoComp(value) {
    this.setState({
      showAutoComp: value
    })
  }

  IncrementItem = (type) => {
    switch (type) {
      case "adult":
        this.setState({ searchParams: { ...this.state.searchParams, adult: parseInt(this.state.searchParams.adult) + 1 } });
        break;
      case "enfant":
        this.setState({ searchParams: { ...this.state.searchParams, enfant: this.state.searchParams.enfant + 1 } });
        break;
      case "room":
        this.setState({ searchParams: { ...this.state.searchParams, room: this.state.searchParams.room + 1 } });
        break;
      default:
        break;
    }
  }
  DecreaseItem = (type) => {
    switch (type) {
      case "adult":
        if (parseInt(this.state.searchParams.adult) <= 1) {
          this.setState({ searchParams: { ...this.state.searchParams, adult: 1 } });
        } else {
          this.setState({ searchParams: { ...this.state.searchParams, adult: this.state.searchParams.adult - 1 } });
        }
        break;
      case "enfant":
        if (parseInt(this.state.searchParams.enfant) <= 0) {
          this.setState({ searchParams: { ...this.state.searchParams, enfant: 0 } });
        } else {
          this.setState({ searchParams: { ...this.state.searchParams, enfant: this.state.searchParams.enfant - 1 } });
        }
        break;
      case "room":
        if (parseInt(this.state.searchParams.room) <= 1) {
          this.setState({ searchParams: { ...this.state.searchParams, room: 1 } });
        } else {
          this.setState({ searchParams: { ...this.state.searchParams, room: this.state.searchParams.room - 1 } });
        }
        break;
      default:
        break;
    }
  }
  handleChangeBudget = (event, newValue) => {
    this.setState({ searchParams: { ...this.state.searchParams, budget: newValue } })
  };
  async onChangeDate(newValue) {
    await this.setState({ DateRange: newValue })
    await this.setState({ searchParams: { ...this.state.searchParams, dateDebut: moment(this.state.DateRange[0]).format("YYYY-MM-DD"), dateFin: moment(this.state.DateRange[1]).format("YYYY-MM-DD") } })
  }




  render() {
    const showAutoComp = this.state.showAutoComp
    const region = this.state.searchParams.region
    const citiesDepart = <DropdownItem className="pl-1" onMouseDown={e => { this.city.bind(this)(e, region, "Algerie") }} ><FontAwesomeIcon icon={faMapMarkerAlt} name="region" /> {region}</DropdownItem>

    // const citiesDepart = ['this.state.autocompletePlaces'].map((city, i) => {
    //   // const cityName = city.name;
    //   // const code = city.address.cityCode;
    //   // const country = city.address.countryCode;
    //   // const countryName = city.address.countryName;
    //   return (
    //     <DropdownItem className="pl-1" id={`cityDep` + i} key={city.address.cityCode} onMouseDown={e => { this.city.bind(this)(e, cityName, countryName) }} ><FontAwesomeIcon icon={faMapMarkerAlt} name={city.address.cityCode} /> {cityName} ({code}, {country})</DropdownItem>
    //   )
    // }, this)

    const heberType = ["Hotel", "Studio", "Appartement", "Chambre d'hotes", "Villa", "Auberge", "Bivouac", "Camping", "Bangalow", "Chambre"]
    const repas = ["Petit-déjeuner compris", "Petit-déjeuner et diner", "Tous les repas sont compris", "Logement avec cuisine", "son pension"]
    const equipement = ["Salle de bains privative", "Parking", "Climatisation", "Télévision", "Lave-ligne", "Vue sur mer", "Plage privé", "Balcon", "Wi-Fi", "Insonorisation", "Kitchenette", "Lave-vaisselle", "Lits jumeaux", "Lit double", "Accessibilité en fauteuil routant", "WC anglais", "WC avec douchette", "Piscine", "Jacuzzi", "Salle de fitness", "Sauna", "Spa Jacuzziet", "centre de bien-être", "Acsenceur"]
    const condReserv = ["Annulation Gratuite", "Paiment sur place", "Paiment électronique", "Paiment sécurisé sur site"]

    const heberTypeElm = [];
    const repasElm = [];
    const equiElm = [];
    const condReservElm = [];




    heberType.forEach(elm => {
      heberTypeElm.push(
        <FormGroup check className=" form-check-sidebar"><Label check><Input name='type' type="checkbox" value={elm.toLowerCase()} checked={this.isExist("type", elm)} />{elm}</Label></FormGroup>
      )
    })
    repas.forEach(elm => {
      repasElm.push(
        <FormGroup check className=" form-check-sidebar"><Label check><Input name="repas" type="checkbox" value={elm.toLowerCase()} checked={this.isExist("repas", elm)} />{elm}</Label></FormGroup>
      )
    })
    equipement.forEach(elm => {
      equiElm.push(
        <FormGroup check className=" form-check-sidebar"><Label check><Input name='equipement' type="checkbox" value={elm.toLowerCase()} checked={this.isExist("equipement", elm)} />{elm}</Label></FormGroup>
      )
    })
    condReserv.forEach(elm => {
      condReservElm.push(
        <FormGroup check className=" form-check-sidebar"><Label check><Input name="conditions" type="checkbox" value={elm.toLowerCase()} checked={this.isExist("conditions", elm)} />{elm}</Label></FormGroup>
      )
    })
    const arrayBudget = (this.state.searchParams.budget.toString().split(","))



    return (
      <Container>
        <br />
        <center><span className="side-bar-txt h4">Recherche Acvancée</span></center>
        <br />
        {/* <div> */}
        <div>
          <div className="catego__name" id="cancel-side">Destniation</div>
          <UncontrolledDropdown nav inNavbar>
            <div>
              <input onChange={e => this.changeState(e)} onInput={e => this.autoComplete(e)} onFocus={e => this.showAutoComp(true)} onBlur={e => this.showAutoComp(false)} id="destination" className="Advanced-btn-ser small " placeholder='Turquie' style={{ width: "100%", paddingLeft: "35px", backgroundColor: "white", color: "#37296a" }} name="region" value={this.state.searchParams.region} autoComplete='off' />
              <img src="/imgs/navebar/search_icn.svg" alt="" style={{ position: "absolute", color: "red", left: "8px", top: " 5px" }} />
            </div>

            <DropdownMenu className={`${showAutoComp && 'show'} destination-drop-down`}>
              <div>
                <div className="body-drop-down">

                  <div><FontAwesomeIcon id="search-result" icon={faSearch} /><span id="reslt-title"> Résultat</span></div>

                  <hr />
                  <div className="result-block">
                    {citiesDepart}
                  </div>
                  <span id="recent-title">Récents</span>
                  <hr />
                  <div className="result-block">
                    <div className="recent"><FontAwesomeIcon icon={faSearch} /> Paris,France</div>
                    <div className="recent"><FontAwesomeIcon icon={faSearch} /> Ibiza,Espagne</div>
                    <div className="recent"><FontAwesomeIcon icon={faSearch} /> Dubai,UAE</div>
                  </div>
                </div>
              </div>
            </DropdownMenu>
          </UncontrolledDropdown>

          <div className="catego__name py-2" id="">Date de Depart/Retour</div>
          <UncontrolledDropdown nav inNavbar>
            <div>
              {/* <input onChange={e => this.changeState(e)}  onFocus={e => this.showAutoComp(true)}  id="" className="Advanced-btn-ser small" placeholder='Turquie' style={{ width: "100%", paddingLeft: "35px", backgroundColor: "white", color: "#37296a" }} name="region" value={this.state.searchParams.region} /> */}
              {/* <img src="/imgs/navebar/search_icn.svg" alt="" style={{ position: "absolute", color: "red", left: "8px", top: " 5px" }} /> */}
              <UncontrolledDropdown className="border border-dark p-1 px-3" style={{ borderRadius: "10px" }} nav inNavbar>
                {/* <Calender  returnBool={true} num={0} style={{marginTop:"10px",padding:"0"}}/> */}
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DateRangePicker
                    label="Advanced keyboard"
                    value={this.state.DateRange}
                    onChange={(newValue) => {
                      this.onChangeDate(newValue)

                    }}
                    renderInput={(startProps, endProps) => (
                      <React.Fragment>
                        <input className="border-0 w-50" ref={startProps.inputRef} {...startProps.inputProps} />
                        <input className="border-0 w-50" ref={endProps.inputRef} {...endProps.inputProps} />
                        <img src="/imgs/navebar/search_icn.svg" alt="" style={{ position: "absolute", color: "red", right: "8px", top: " 5px" }} />
                      </React.Fragment>
                    )}
                  />
                </LocalizationProvider>
              </UncontrolledDropdown>
            </div>
          </UncontrolledDropdown>



          <div class=" mt-3 font-weight-bold" id="passg">
            <div className="type__passg d-flex justify-content-between align-items-center mb-2">
              <h6 className='mt-2 pr-2'>Adultes (+11 ans)</h6>
              <div className="type__incDec d-flex align-items-center">
                <button className='filter__inc mx-2' onClick={() => this.DecreaseItem("adult")}><span>-</span></button>
                <span className="mx-2">{parseInt(this.state.searchParams.adult)}</span>
                {/* <input type="number" className="number-input-tarifVoyage" value={this.state.searchParams.adult} /> */}
                <button className='filter__inc mx-2 ' onClick={() => this.IncrementItem("adult")}><span>+</span></button>
              </div>
            </div>
            <div className="type__passg d-flex justify-content-between  align-items-center mb-2">
              <h6 className='mt-2 pr-2'>Enfants (2- 11 ans)</h6>
              <div className="type__incDec d-flex align-items-center">
                <button className='filter__inc mx-2' onClick={() => this.DecreaseItem("enfant")}><span>-</span></button>
                <span className="mx-2">{parseInt(this.state.searchParams.enfant)}</span>
                <button className='filter__inc mx-2' onClick={() => this.IncrementItem("enfant")}><span>+</span></button>
              </div>
            </div>
            <div className="type__passg d-flex justify-content-between align-items-center ">
              <h6 className='mt-2 pr-2'>Chambres </h6>
              <div className="type__incDec d-flex align-items-center">
                <button className='filter__inc mx-2' onClick={() => this.DecreaseItem("room")}><span>-</span></button>
                <span className="mx-2">{this.state.searchParams.room}</span>
                <button className='filter__inc mx-2' onClick={() => this.IncrementItem("room")}><span>+</span></button>
              </div>
            </div>




          </div>


          <div class="mt-3" id="price">
            <span><b>{arrayBudget[0]}</b> DZD - <b>{arrayBudget[1]}</b> DZD</span>
            <Slider
              // getAriaLabel={() => 'Temperature range'}
              value={arrayBudget}
              onChange={(event, newValue) => this.handleChangeBudget(event, newValue)}
              valueLabelDisplay="auto"
              min={0}
              max={10000}
              step={250}
            />

          </div>

          <form onChange={e => { this.changeState(e) }}>
            {/* <div className="options-sidebar mt-4">
                <div className="lablel-sidebar-bidget mb-1">Votre Budget</div>
                 <FormGroup check className="check-box form-check-sidebar"><Label check><Input type="radio" value="0-19999" name="budget" checked={this.isExist("budget","0-19999")}  />0-19999DZD</Label></FormGroup>
                 <FormGroup check className="check-box form-check-sidebar"><Label check><Input type="radio" value="20000-49000" name="budget" checked={this.isExist("budget","20000-49000")}/>20 000-49 000DZD</Label></FormGroup>
                 <FormGroup check className="check-box form-check-sidebar"><Label check><Input type="radio" value="50000-99999" name="budget" checked={this.isExist("budget","50000-99999")}/>50 000-99 999DZD</Label></FormGroup>
                 <FormGroup check className="check-box form-check-sidebar"><Label check><Input type="radio" value="100000-199999" name="budget" checked={this.isExist("budget","100000-199999")}/>100 000-199 999DZD</Label></FormGroup>
                 <FormGroup check className="check-box form-check-sidebar"><Label check><Input type="radio" value="200000-99999999" name="budget" checked={this.isExist("budget","200000-99999999")}/>+200 000DZD</Label></FormGroup>
                 </div> */}

            {/* <div className="options-sidebar mt-2">
                <div className="lablel-sidebar-bidget mb-1">Type d'établissement</div>
                {heberTypeElm}
                </div> */}
            <div> <hr className='mt-2' /></div>
            <a data-toggle="collapse" className='show' aria-expanded="true" href="#typeHeb" role="button" aria-controls="typeHeb">
              <div className="filter__catego  show d-flex justify-content-between align-items-center">
                <span className='catego__name'>Type d'établissement</span>
                <FontAwesomeIcon color='#37296a' icon={faChevronDown} />
              </div>
            </a>
            <div class="collapse show justify-content-start mt-3" id="typeHeb">
              {heberTypeElm}
            </div>


            {/* <div className="options-sidebar mt-2">
                 <div className="lablel-sidebar-bidget mb-1">Repas</div>
                {repasElm}
                 </div> */}

            <div> <hr className='mt-2' /></div>
            <a data-toggle="collapse" className='show' aria-expanded="true" href="#Repas" role="button" aria-controls="Repas">
              <div className="filter__catego  show d-flex justify-content-between align-items-center">
                <span className='catego__name'>Repas</span>
                <FontAwesomeIcon color='#37296a' icon={faChevronDown} />
              </div>
            </a>
            <div class="collapse show justify-content-start mt-3" id="Repas">
              {repasElm}
            </div>

            {/* <div className="options-sidebar mt-2">
                 <div className="lablel-sidebar-bidget mb-1">Condition de réservation</div>
                 {condReservElm}
                 </div> */}

            <div> <hr className='mt-2' /></div>
            <a data-toggle="collapse" className='show' aria-expanded="true" href="#Condition" role="button" aria-controls="Condition">
              <div className="filter__catego  show d-flex justify-content-between align-items-center">
                <span className='catego__name'>Condition de réservation</span>
                <FontAwesomeIcon color='#37296a' icon={faChevronDown} />
              </div>
            </a>
            <div class="collapse show justify-content-start mt-3" id="Condition">
              {condReservElm}
            </div>

            {/* <div className="options-sidebar mt-2 mb-4">
                 <div className="lablel-sidebar-bidget mb-1">Equipements</div>                  
                 {equiElm}
                 </div> */}

            <div> <hr className='mt-2' /></div>
            <a data-toggle="collapse" className='show' aria-expanded="true" href="#equip" role="button" aria-controls="equip">
              <div className="filter__catego  show d-flex justify-content-between align-items-center">
                <span className='catego__name'>Equipements</span>
                <FontAwesomeIcon color='#37296a' icon={faChevronDown} />
              </div>
            </a>
            <div class="collapse show justify-content-start mt-3" id="equip">
              {equiElm}
            </div>

          </form>
        </div>
        {/* </div> */}

      </Container>
    );
  }
}


function mapStateToProps(state) {
  return {
    url: state.sideBareHebergement.url,
    redirect: state.sideBareHebergement.redirect,
    params: state.sideBareHebergement.sideBar
  };
}

//connect function INJECTS dispatch function as a prop!!
export default withRouter(connect(mapStateToProps)(SideBarHeberg));